export default {
  管理员: '管理員',
  邀请您加入: '邀請您加入',
  立即加入: '立即加入',
  拒绝: '拒絕',
  验证身份后加入: '驗證身份後加入',
  验证码已发送至: '驗證碼已發送至',
  '5分钟内有效': '5 分鐘內有效',
  重新发送: '重新發送',
  正在处理: '處理中',
  加入成功: '加入成功',
  打开腾讯元宝: '開啟騰訊元寶',
  当前链接已失效: '當前連結已失效',
  '邀请链接已失效，请联系管理员重新发送有效链接': '邀請連結已失效，請聯絡管理員重新發送有效連結',
  提示: '注意',
  '拒绝后如需重新加入，需联系管理员再次邀请，请谨慎操作':
    '拒絕後如需重新加入，需聯絡管理員再次邀請，請謹慎操作',
  取消: '取消',
  确认拒绝: '確認拒絕',
  已拒绝: '已拒絕',
  '您已拒绝管理员的“{name}”加入邀请，如需重新加入，请联系管理员再次邀请。':
    '您已拒絕管理員的“{name}”加入邀請，如需重新加入，請聯絡管理員再次邀請。',
  前往使用: '前往使用',
  服务协议与隐私政策: '服務條款和隱私權保護',
  服务协议: '服務條款',
  隐私政策: '隱私權保護',
};
